import { render } from "./DeveloperItemComposer.vue?vue&type=template&id=4a5e1c00"
import script from "./DeveloperItemComposer.vue?vue&type=script&lang=js"
export * from "./DeveloperItemComposer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__